/* eslint-disable eqeqeq */
const removerMascara = str => {
    return str.replace(/\D/g, '');
};

const validarCpfCnpj = cpfCnpj => {
    let val = removerMascara(cpfCnpj);

    if (val.length == 11) {
        let cpf = val.trim();
        cpf = cpf.replace(/\D/g, '');

        cpf = cpf.replace(/\./g, '');
        cpf = cpf.replace('-', '');
        cpf = cpf.split('');
        let v1 = 0;
        let v2 = 0;
        let aux = false;

        for (let i = 1; cpf.length > i; i++) {
            if (cpf[i - 1] != cpf[i]) {
                aux = true;
            }
        }

        if (aux == false) {
            return false;
        }

        for (let i = 0, p = 10; cpf.length - 2 > i; i++, p--) {
            v1 += cpf[i] * p;
        }

        v1 = (v1 * 10) % 11;

        if (v1 == 10) {
            v1 = 0;
        }

        if (v1 != cpf[9]) {
            return false;
        }

        for (let i = 0, p = 11; cpf.length - 1 > i; i++, p--) {
            v2 += cpf[i] * p;
        }

        v2 = (v2 * 10) % 11;

        if (v2 == 10) {
            v2 = 0;
        }

        if (v2 != cpf[10]) {
            return false;
        } else {
            return true;
        }
    } else if (val.length == 14) {
        let cnpj = val.trim();

        cnpj = cnpj.replace(/\./g, '');
        cnpj = cnpj.replace('-', '');
        cnpj = cnpj.replace('/', '');
        cnpj = cnpj.split('');

        let v1 = 0;
        let v2 = 0;
        let aux = false;

        for (let i = 1; cnpj.length > i; i++) {
            if (cnpj[i - 1] != cnpj[i]) {
                aux = true;
            }
        }

        if (aux == false) {
            return false;
        }

        for (let i = 0, p1 = 5, p2 = 13; cnpj.length - 2 > i; i++, p1--, p2--) {
            if (p1 >= 2) {
                v1 += cnpj[i] * p1;
            } else {
                v1 += cnpj[i] * p2;
            }
        }

        v1 = v1 % 11;

        if (v1 < 2) {
            v1 = 0;
        } else {
            v1 = 11 - v1;
        }

        if (v1 != cnpj[12]) {
            return false;
        }

        for (let i = 0, p1 = 6, p2 = 14; cnpj.length - 1 > i; i++, p1--, p2--) {
            if (p1 >= 2) {
                v2 += cnpj[i] * p1;
            } else {
                v2 += cnpj[i] * p2;
            }
        }

        v2 = v2 % 11;

        if (v2 < 2) {
            v2 = 0;
        } else {
            v2 = 11 - v2;
        }

        if (v2 != cnpj[13]) {
            return false;
        } else {
            return true;
        }
    }
    // if (val.length == 9 || val.length == 10 || val.length == 11) {
    //     let ruc = val.trim();

    //     ruc = ruc.replace(/\./g, '');
    //     ruc = ruc.replace('-', '');
    //     ruc = ruc.split('');

    //     if (ruc.length == 8 || ruc.length == 9 || ruc.length == 11) {
    //         return true;
    //     }
    // } else {
    //     return false;
    // }
};

const validarCpf = val => {
    if (val && val.length == 14) {
        let cpf = val.trim();

        cpf = cpf.replace(/\./g, '');
        cpf = cpf.replace('-', '');
        cpf = cpf.split('');

        let v1 = 0;
        let v2 = 0;
        let aux = false;

        for (let i = 1; cpf.length > i; i++) {
            if (cpf[i - 1] != cpf[i]) {
                aux = true;
            }
        }

        if (aux == false) {
            return false;
        }

        for (let i = 0, p = 10; cpf.length - 2 > i; i++, p--) {
            v1 += cpf[i] * p;
        }

        v1 = (v1 * 10) % 11;

        if (v1 == 10) {
            v1 = 0;
        }

        if (v1 != cpf[9]) {
            return false;
        }

        for (let i = 0, p = 11; cpf.length - 1 > i; i++, p--) {
            v2 += cpf[i] * p;
        }

        v2 = (v2 * 10) % 11;

        if (v2 == 10) {
            v2 = 0;
        }

        if (v2 != cpf[10]) {
            return false;
        } else {
            return true;
        }
    }

    return false;
};

const validarCnpj = cnpj => {
    cnpj = removerMascara(cnpj);
    let length = cnpj.length;

    if (cnpj === '') return false;
    if (length != 14) return false;

    length = length - 2;
    let values = cnpj.substring(0, length);
    const digits = cnpj.substring(length);
    let sum = 0;
    let pos = length - 7;
    for (let i = length; i >= 1; i--) {
        sum += values.charAt(length - i) * pos--;
        if (pos < 2) pos = 9;
    }
    let result = sum % 11 < 2 ? 0 : 11 - (sum % 11);

    if (result != digits.charAt(0)) return false;
    length = length + 1;
    values = cnpj.substring(0, length);
    sum = 0;
    pos = length - 7;
    for (let i = length; i >= 1; i--) {
        sum += values.charAt(length - i) * pos--;
        if (pos < 2) pos = 9;
    }
    result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
    if (result != digits.charAt(1)) return false;

    return true;
};

export default {
    validarCpfCnpj,
    validarCpf,
    validarCnpj
};
